// Character counts complement the form-level Flow validation errors.
import React from 'react';

export default function FlowLengthHint({ value, limit, enabled = true, menuPreview = false }) {
  if (!enabled) return null;
  const count = Array.from(value || '').length;
  const displayLimit = limit.toLocaleString('en-US');
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1em',
        color: !menuPreview && count > limit ? '#9f3a38' : '#666',
        fontSize: '0.85em',
      }}
    >
      <span>Maximum {displayLimit} characters for WhatsApp Flows.{menuPreview && ' Excess text will be truncated.'}</span>
      <span aria-label={`${count} of ${limit} characters`}>
        {count}/{limit}
      </span>
    </div>
  );
}
